import * as type from '../types/company'



export const retrieveCompanyDetails = payload => {
    return{
        type: type.REQUEST_COMPANY_DETAILS,
        payload: payload
    }
}

export const resetCompanyDetails = () => {
    return{
        type: type.RESET_COMPANY_DETAILS
    }
}

export const changeCompanyModal = payload => {
    return{
        type: type.CHANGE_COMPANY_MODALS,
        modal: payload
    }
}

export const retrieveCompanyTeam = payload => {
    return{
        type: type.REQUEST_COMPANY_TEAM,
        payload: payload
    }
}

export const resetCompanyTeam = () => {
    return{
        type: type.RESET_COMPANY_TEAM
    }
}

export const retrieveCompanyImage = payload => {
    return{
        type: type.REQUEST_COMPANY_IMAGE,
        payload: payload
    }
}

export const resetCompanyImage = () => {
    return{
        type: type.RESET_COMPANY_IMAGE
    }
}

export const requestUpdateCompanyImage = payload => {
    return{
        type: type.REQUEST_UPDATE_COMPANY_IMAGE,
        details: payload
    }
}

export const resetUpdateCompanyImage = () => {
    return{
        type: type.RESET_UPDATE_COMPANY_IMAGE
    }
}

export const requestDeleteCompanyImage = payload => {
    return{
        type: type.REQUEST_DELETE_COMPANY_IMAGE,
        details: payload
    }
}

export const resetDeleteCompanyImage = () => {
    return{
        type: type.RESET_DELETE_COMPANY_IMAGE
    }
}

export const retrieveCompanyReceipts = payload => {
    return{
        type: type.REQUEST_COMPANY_RECEIPTS,
        payload: payload
    }
}

export const resetCompanyReceipts = () => {
    return{
        type: type.RESET_COMPANY_RECEIPTS
    }
}

export const retrieveCompanySubscription = payload => {
    return{
        type: type.REQUEST_COMPANY_SUBSCRIPTION,
        payload: payload
    }
}

export const resetCompanySubscription = () => {
    return{
        type: type.RESET_COMPANY_SUBSCRIPTION
    }
}

export const requestDeleteSubscription = payload => {
    return{
        type: type.REQUEST_SUBSCRIPTION_DELETION,
        payload: payload
    }
}

export const resetDeleteSubscription = () => {
    return{
        type: type.RESET_SUBSCRIPTION_DELETION
    }
}

export const requestSendInvitation = payload => {
    return{
        type: type.REQUEST_SEND_INVITATION,
        payload: payload
    }
}

export const resetSendInvitation = () => {
    return{
        type: type.RESET_SEND_INVITATION
    }
}

export const requestDeleteCompany = payload => {
    return{
        type: type.REQUEST_DELETE_COMPANY,
        payload: payload
    }
}

export const resetDeleteCompany = () => {
    return{
        type: type.RESET_DELETE_COMPANY
    }
}

export const requestDeleteMember = payload => {
    return{
        type: type.REQUEST_DELETE_MEMBER,
        payload: payload
    }
}

export const resetDeleteMember = () => {
    return{
        type: type.RESET_DELETE_MEMBER
    }
}

export const setActiveMemberId = payload => {
    return{
        type: type.SET_ACTIVE_EDIT_MEMBER,
        details: payload
    }
}

export const resetActiveMemberId = () => {
    return{
        type: type.RESET_ACTIVE_EDIT_MEMBER
    }
}

export const setActiveSubscription = payload => {
    return{
        type: type.SET_ACTIVE_SUBSCRIPTION,
        details: payload
    }
}

export const resetActiveSubscription = () => {
    return{
        type: type.RESET_ACTIVE_SUBSCRIPTION
    }
}

export const requestChangeMember = payload => {
    return{
        type: type.REQUEST_CHANGE_MEMBER,
        payload: payload
    }
}

export const resetChangeMember = () => {
    return{
        type: type.RESET_CHANGE_MEMBER
    }
}

export const requestUpdateCompanyDetails = payload => {
    return{
        type: type.REQUEST_UPDATE_COMPANY_DETAILS,
        payload: payload
    }
}

export const resetUpdateCompanyDetails = () => {
    return{
        type: type.RESET_UPDATE_COMPANY_DETAILS
    }
}

export const retrieveCompanyPaymentMethods = payload => {
    return{
        type: type.REQUEST_COMPANY_PAYMENT_METHODS,
        payload: payload
    }
}

export const resetCompanyPaymentMethods = () => {
    return{
        type: type.RESET_COMPANY_PAYMENT_METHODS
    }
}

export const requestDeletePaymentMethod = payload => {
    return{
        type: type.REQUEST_DELETE_PAYMENT_METHOD,
        payload: payload
    }
}

export const resetDeletePaymentMethod = () => {
    return{
        type: type.RESET_DELETE_PAYMENT_METHOD
    }
}

export const setActivePaymentMethod = payload => {
    return{
        type: type.SET_ACTIVE_PAYMENT_METHOD,
        details: payload
    }
}

export const resetActivePaymentMethod = () => {
    return{
        type: type.RESET_ACTIVE_PAYMENT_METHOD
    }
}

export const requestAddPaymentMethod = payload => {
    return{
        type: type.REQUEST_ADD_PAYMENT_METHOD,
        payload: payload
    }
}

export const resetAddPaymentMethod = () => {
    return{
        type: type.RESET_ADD_PAYMENT_METHOD
    }
}

export const requestUpdatePaymentMethod = payload => {
    return{
        type: type.REQUEST_UPDATE_PAYMENT_METHOD,
        payload: payload
    }
}

export const resetUpdatePaymentMethod = () => {
    return{
        type: type.RESET_UPDATE_PAYMENT_METHOD
    }
}

export const requestUpdateLicenseQuantity = payload => {
    return{
        type: type.REQUEST_UPDATE_LICENSE_QUANTITY,
        payload: payload
    }
}

export const resetUpdateLicenseQuantity = () => {
    return{
        type: type.RESET_UPDATE_LICENSE_QUANTITY
    }
}

export const retrieveCompanyChannels = payload => {
    return{
        type: type.REQUEST_COMPANY_CHANNELS,
        payload: payload
    }
}

export const resetCompanyChannels = () => {
    return{
        type: type.RESET_COMPANY_CHANNELS
    }
}